import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        marginBottom: 12, 
        width: '100%', 
        background: '#1b2039', 
        borderRadius: 4
    },
    wrapLabel: {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: 50, 
        borderBottom: '1px solid rgba(0,0,0,.3)'
    },
    text: {
        fontFamily: 'Montserrat, sans-serif', 
        color: '#fff'
    },
    w150: {
        width: 150
    },
    wrapItems: {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        flexDirection: 'column', 
        paddingTop: 10, 
        paddingBottom: 10, 
        width: '100%'
    },
    wrapItem: {
        width: '90%', 
        padding: 10, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center'
    },
    bg: {
        background: 'rgb(20,27,51)'
    }
}))

export {
    useStyles
}